import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteNps() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((npsId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/nps/${npsId}`, { headers: { Authorization: sessionStorage.getItem('token') } })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
